module.exports = __webpack_public_path__ + "img/流体力学2_3.c25f8e6d.jpg";